import { JsonLd } from './JsonLd';
import {
  SITE_URL,
  ORG_ID,
  ORG_NAME,
  ORG_ALT_NAME,
  ORG_LOGO,
  ORG_SAME_AS,
  FOUNDER_PERSON,
} from './constants';

/**
 * EducationalOrganization JSON-LD for SWTPA, with the founder modelled as a
 * Person entity carrying the LCSW credential — the E-E-A-T signal that 2026
 * search + AI engines reward for a professional/YMYL topic.
 */
export function buildOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    '@id': ORG_ID,
    name: ORG_NAME,
    alternateName: ORG_ALT_NAME,
    url: SITE_URL,
    logo: ORG_LOGO,
    description:
      'Adaptive ASWB social work licensing-exam preparation, built around practice questions reviewed by a Licensed Clinical Social Worker.',
    founder: FOUNDER_PERSON,
    sameAs: ORG_SAME_AS as string[],
  };
}

export function OrganizationSchema() {
  return <JsonLd data={buildOrganizationSchema()} />;
}
